export const Login = '/';
export const Dashboard = '/dashboard/';
export const Home = '/dashboard/home';
export const Cliente = '/dashboard/cliente/';
export const ClienteAtualizar = '/dashboard/cliente-cadastrar/:id/detalhe';
export const ClienteCadastrar = '/dashboard/cliente-cadastrar';
export const Usuario = '/dashboard/usuario/';
export const UsuarioAtualizar = '/dashboard/usuario-cadastrar/:id/detalhe';
export const UsuarioCadastrar = '/dashboard/usuario-cadastrar/';
export const Banco = '/dashboard/banco/';
export const BancoCadastrar = '/dashboard/banco-cadastrar/';
export const BancoAtualizar = '/dashboard/banco-cadastrar/:id/detalhe';
export const Produto = '/dashboard/produto/';
export const ProdutoCadastrar = '/dashboard/produto-cadastrar/';
export const ProdutoAtualizar = '/dashboard/produto-cadastrar/:id/detalhe';
export const PrestacaoDeContas = '/dashboard/prestacao-de-contas/';
export const PrestacaoDeContasCadastro = '/dashboard/prestacao-de-contas-cadastro/';
export const CondicaoPagamento = '/dashboard/condicaopagamento/';
export const CondicaoPagamentoCadastrar = '/dashboard/condicaopagamento-cadastrar/';
export const CondicaoPagamentoAtualizar = '/dashboard/condicaopagamento-cadastrar/:id/detalhe';
export const TipoPagamento = '/dashboard/tipopagamento/';
export const TipoPagamentoCadastrar = '/dashboard/tipopagamento-cadastrar/';
export const TipoPagamentoAtualizar = '/dashboard/tipopagamento-cadastrar/:id/detalhe';
export const CategoriaFinanceira = '/dashboard/categoriafinanceira/';
export const CategoriaFinanceiraCadastrar = '/dashboard/categoriafinanceira-cadastrar/';
export const CategoriaFinanceiraAtualizar = '/dashboard/categoriafinanceira-cadastrar/:id/detalhe';
export const ContaBancaria = '/dashboard/contabancaria/';
export const ContaBancariaCadastrar = '/dashboard/contabancaria-cadastrar/';
export const ContaBancariaAtualizar = '/dashboard/contabancaria-cadastrar/:id/detalhe';
export const CentroCusto = '/dashboard/centrocusto/';
export const CentroCustoCadastrar = '/dashboard/centrocusto-cadastrar/';
export const CentroCustoAtualizar = '/dashboard/centrocusto-cadastrar/:id/detalhe';
export const GrupoProduto = '/dashboard/grupoproduto/';
export const GrupoProdutoCadastrar = '/dashboard/grupoproduto-cadastrar/';
export const GrupoProdutoAtualizar = '/dashboard/grupoproduto-cadastrar/:id/detalhe';
export const Fornecedor = '/dashboard/fornecedor/';
export const FornecedorCadastrar = '/dashboard/fornecedor-cadastrar/';
export const FornecedorAtualizar = '/dashboard/fornecedor-cadastrar/:id/detalhe';
export const Marca = '/dashboard/marca/';
export const MarcaCadastrar = '/dashboard/marca-cadastrar/';
export const MarcaAtualizar = '/dashboard/marca-cadastrar/:id/detalhe';
export const Fabricante = '/dashboard/fabricante/';
export const FabricanteCadastrar = '/dashboard/fabricante-cadastrar/';
export const FabricanteAtualizar = '/dashboard/fabricante-cadastrar/:id/detalhe';
export const Modelo = '/dashboard/modelo/';
export const ModeloCadastrar = '/dashboard/modelo-cadastrar/';
export const ModeloAtualizar = '/dashboard/modelo-cadastrar/:id/detalhe';
export const UnidadeMedida = '/dashboard/unidademedida/';
export const UnidadeMedidaCadastrar = '/dashboard/unidademedida-cadastrar/';
export const UnidadeMedidaAtualizar = '/dashboard/unidademedida-cadastrar/:id/detalhe';
export const FormaPagamento = '/dashboard/formapagamento/';
export const FormaPagamentoCadastrar = '/dashboard/formapagamento-cadastrar/';
export const FormaPagamentoAtualizar = '/dashboard/formapagamento-cadastrar/:id/detalhe';
export const PedidoCadastrar = '/dashboard/pedido/cadastrar';
export const PedidoAtualizar = '/dashboard/pedido/:id/detalhe';
export const Pedido = '/dashboard/pedido';
export const AdicionarProdutoCadastrar = '/dashboard/adicionarproduto-cadastrar';
export const ImportacaoXML = '/dashboard/importacaoxml/';
export const ImportacaoXMLCadastrar = '/dashboard/importacaoxml-cadastrar/';
export const ContasReceber = '/dashboard/contasreceber/';
export const ContasReceberCadastrar = '/dashboard/contasrecebercadastrar/';
export const ContasReceberLancamento = '/dashboard/contasreceber-lancamento/:id/lancamento';
export const GrupoCliente = '/dashboard/grupocliente/';
export const GrupoClienteCadastrar = '/dashboard/grupocliente-cadastrar/';
export const GrupoClienteAtulizar = '/dashboard/grupocliente-cadastrar/:id/detalhe';
export const OrdemServico = '/dashboard/ordemservico/';
export const OrdemServicoCadastrar = '/dashboard/ordemservico-cadastrar/';
export const OrdemServicoCloning = '/dashboard/ordemservico-clonar/:id';
export const OrdemServicoAtualizar = '/dashboard/ordemservico-cadastrar/:id/detalhe';
export const ContasPagar = '/dashboard/contaspagar/';
export const ContasPagarCadastrar = '/dashboard/contaspagar-cadastrar/';
export const ContasPagarAtualizar = '/dashboard/contaspagar-cadastrar/:id/detalhe';
export const Cfop = '/dashboard/cfop/';
export const CfopCadastrar = '/dashboard/cfop-cadastrar/';
export const CfopAtualizar = '/dashboard/cfop-cadastrar/:id/detalhe';
export const Maquina = '/dashboard/maquina/';
export const MaquinaCadastrar = '/dashboard/maquina-cadastrar/';
export const MaquinaAtualizar = '/dashboard/maquina-cadastrar/:id/detalhe';
export const MaquinaConsultar = '/dashboard/maquina-consultar/:id/consulta';
export const CaixaLancamento = '/dashboard/caixa-lancamento';
export const NotaFiscal = '/dashboard/nota-fiscal';
export const Boleto = '/dashboard/boleto';
export const MovimentacaoEstoque = '/dashboard/movimentacao-estoque/';
export const ReajusteEstoque = '/dashboard/reajuste-estoque/';
export const ReajusteEstoqueCadastrar = '/dashboard/reajuste-estoque-cadastrar/';
